import RequestClient from "./requestClient";

export const api = new RequestClient(process.env.REACT_APP_API_URL!);
export const rootApi = new RequestClient(process.env.REACT_APP_ROOT_API_URL!);
